import { Card } from "@scuf/common";
import { Chart } from "@scuf/charts";
import React, { useEffect, useState } from "react";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import "../TGases.css";
import { plotBackground } from "../../../config/colors";


export default function CalcinaProduciaTeorica() {
  const [calcopirita, setCalcopirita] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [bornita, setBornita] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [enargita, setEnargita] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [tenantita, setTenantita] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [cuprita, setCuprita] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [magnetita, setMagnetita] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [silicice, setSilicice] = useState({
    value: [],
    fecha: [],
    estado: [],
  });

  const [ganga, setGanga] = useState({
    value: [],
    fecha: [],
    estado: [],
  });



  // Fecha inicial y final
  const [date, setDate] = useState({ start: "19-01-2023", end: "25-01-2023" });

  // Objeto inicial de la peticion
  const initialFetch = {
    idSeccion: 3,
    secuencia: 46,
    ultimo: 0,
    frecuencia: 5,
    dias: 7,
  };

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      // Solo nos traemos la data de la peticion
    const { data } = await getValoresPeriodo(initialFetch);

    populateCalcopirita(data);
    populateBornita(data);
    populateEnargita(data);
    populateTenantita(data);
    populateCuprita(data);
    populateMagnetita(data);
    populateSilicice(data);
    populateGanga(data);
      //#endregion
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCalcopirita(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%Calcopirita en Calcina Teórica"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCalcopirita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateBornita(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%Bornita en Calcina Teórica"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setBornita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateEnargita(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%Enargita en Calcina Teórica"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setEnargita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTenantita(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%Tenantita en Calcina Teórica"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setTenantita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCuprita(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%Cuprita en Calcina Teórica"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setCuprita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateMagnetita(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%Magnetita en Calcina Teórica"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setMagnetita({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateSilicice(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%Sílice en Calcina Teórica"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setSilicice({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateGanga(data) {
    const arrValues = [];
    const arrFechas = [];
    const arrData = data.filter(
      (element) => element.Detalle === "%Ganga en Calcina Teórica"
    );
    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setDate({ start: arrFechas[0], end: arrFechas[arrFechas.length - 1] });

    setGanga({
      fecha: arrFechas,
      value: arrValues,
    });
  }

 
  return (
    <>
       <Card>
        <Card.Content>
          <Chart
            plotBackgroundColor={plotBackground}
            title={"Perfil Calcina Producida Teórica"}
            subtitle={"Periodo " + date.start + " - " + date.end}
          >
            {/** -------------------------------- %Calcopirita en Calcina Teórica --------------------------------------- */}
            <Chart.Line
              name="%Calcopirita en Calcina Teórica"
              data={calcopirita.value}
              yAxis={0}
            />
            {/** -------------------------------- %Bornita en Calcina Teórica --------------------------------------- */}
            <Chart.Line
              name="%Bornita en Calcina Teórica"
              data={bornita.value}
              yAxis={0}
            />
            {/** -------------------------------- %Enargita en Calcina Teórica --------------------------------------- */}
            <Chart.Line
              name="%Enargita en Calcina Teórica"
              data={enargita.value}
              yAxis={1}
            />
            {/** -------------------------------- %Tenantita en Calcina Teórica --------------------------------------- */}
            <Chart.Line
              name="%Tenantita en Calcina Teórica"
              data={tenantita.value}
              yAxis={1}
            />
            {/** -------------------------------- %Cuprita en Calcina Teórica --------------------------------------- */}
            <Chart.Line
              name="%Cuprita en Calcina Teórica"
              data={cuprita.value}
              yAxis={0}
            />
            {/** -------------------------------- %Magnetita en Calcina Teórica --------------------------------------- */}
            <Chart.Line
              name="%Magnetita en Calcina Teórica"
              data={magnetita.value}
              yAxis={0}
            />
            {/** -------------------------------- %Sílice en Calcina Teórica --------------------------------------- */}
            <Chart.Line
              name="%Sílice en Calcina Teórica"
              data={silicice.value}
              yAxis={0}
            />
            {/** -------------------------------- %Ganga en Calcina Teórica --------------------------------------- */}
            <Chart.Line
              name="%As2S3 Salida Ciclones"
              data={ganga.value}
              yAxis={0}
            />

            {/** -------------------------------- FECHAS --------------------------------------- */}
            <Chart.XAxis categories={calcopirita.fecha} />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido, %"
              lineWidth={2}
              lineColor="white"
              min={0}
              max={45}
            />

            <Chart.YAxis
              labelSuffix=" %"
              title="Contenido En-Ten, %"
              lineWidth={2}
              opposite={true}
              lineColor="white"
              min={0}
              max={4.5}
            />

            <Chart.Tooltip valueSuffix="" />
          </Chart>
        </Card.Content>
      </Card>
    </>
  );
}
